"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { Autocomplete } from "@base-ui/react/autocomplete";
import { forwardRef, useCallback } from "react";
import { CdnIcon } from "../CdnIcon/index.js";
import { HorizonIcon } from "../HorizonIcon/index.js";
import { Span } from "../Text/index.js";
import { baseAutocompleteItemVariants } from "./BaseAutocompleteItem.variants.js";
const ITEM_LOCATION_TYPES = {
    AIRPORT: 'flight',
    POI: 'pin_drop',
    GEO: 'my_location',
    HOTEL: 'hotel',
    NEIGHBOURHOOD: 'home_work'
};
function getIconName(itemLocationType) {
    return ITEM_LOCATION_TYPES[itemLocationType] || 'location_city';
}
const BaseAutocompleteItemInner = /*#__PURE__*/ forwardRef(function({ value, firstLine, secondLine, leftNode, rightNode, itemType, iconName, isHighlightedWithKeyboard, isIndented, index, disabled = false, handleItemSelect, ...rest }, ref) {
    const { itemWrapperSlot, leftNodeAndTextSlot, leftNodeIconWrapperSlot, textSlot, rightNodeSlot } = baseAutocompleteItemVariants({
        isHighlightedWithKeyboard,
        isIndented
    });
    const resolvedIcon = iconName ?? (itemType ? getIconName(itemType) : void 0);
    let resolvedLeftNode = leftNode ?? (resolvedIcon && /*#__PURE__*/ jsx(CdnIcon, {
        palette: "primary",
        shade: "10",
        iconName: resolvedIcon,
        size: "24"
    }));
    if ('AI_QUERY' === itemType) resolvedLeftNode = /*#__PURE__*/ jsx(HorizonIcon, {
        name: "AiSearch",
        palette: "primary",
        size: "24"
    });
    const handleClick = useCallback(()=>{
        if (disabled) return;
        handleItemSelect?.(value, index);
    }, [
        handleItemSelect,
        value,
        index,
        disabled
    ]);
    return /*#__PURE__*/ jsxs(Autocomplete.Item, {
        ...rest,
        ref: ref,
        value: value,
        disabled: disabled,
        className: itemWrapperSlot(),
        onClick: handleClick,
        children: [
            /*#__PURE__*/ jsxs("div", {
                className: leftNodeAndTextSlot(),
                children: [
                    resolvedLeftNode && /*#__PURE__*/ jsx("div", {
                        className: leftNodeIconWrapperSlot(),
                        children: resolvedLeftNode
                    }),
                    /*#__PURE__*/ jsxs("div", {
                        className: textSlot(),
                        children: [
                            /*#__PURE__*/ jsx(Span, {
                                textStyle: "body2",
                                overflow: "ellipsis",
                                lineClamp: secondLine ? 1 : 2,
                                children: firstLine
                            }),
                            secondLine && /*#__PURE__*/ jsx(Span, {
                                textStyle: "body3",
                                overflow: "ellipsis",
                                children: secondLine
                            })
                        ]
                    })
                ]
            }),
            rightNode && /*#__PURE__*/ jsx("div", {
                className: rightNodeSlot(),
                children: rightNode
            })
        ]
    });
});
const BaseAutocompleteItem_BaseAutocompleteItem = BaseAutocompleteItemInner;
export { BaseAutocompleteItem_BaseAutocompleteItem as BaseAutocompleteItem };
